<template>
  <div>
    <a-spin :spinning="spinning">
      <a-list itemLayout="horizontal">
        <a-list-item
          v-for="item in msgList"
          :key="item.index"
          class="notification"
        >
          <a-list-item-meta @click="routerTo(item.id)">
            <span
              slot="title"
              v-if="item.messageType === '0'"
            > 系统公告 </span>
            <span
              slot="title"
              v-if="item.messageType === '1'"
            > 学校公告 </span>
            <span
              slot="title"
              v-if="item.messageType === '2'"
            > 反馈回复 </span>
            <span
              slot="title"
              v-if="item.messageType === '3'"
            > 系统消息 </span>
            <div
              slot="description"
              style="width:500px"
            >
              <ellipsis :length="80">
                {{ item.msgSummary }}
              </ellipsis>
            </div>
            <img
              v-if="item.isRead === '0'"
              slot="avatar"
              class="dustyl"
              src="@/assets/nodu.png"
            />
            <img
              v-else
              slot="avatar"
              class="dustyl"
              src="@/assets/du.png"
            />
          </a-list-item-meta>
          <template>
            <div>{{ item.createDate| parseTime('{y}-{m}-{d} {h}:{i}') }}</div>
            <div
              style="color:red;margin-left:10px"
              v-if="item.isRead === '0'"
            >未读</div>
            <div
              style="color:green;margin-left:10px"
              v-else
            >已读
              <a-divider type="vertical" />
              <span
                @click="remove(item.id)"
                style="color:red;"
              >删除</span>
            </div>
          </template>
        </a-list-item>
      </a-list>
      <div style="margin-top: 30px; float: right;">
        <a-pagination
          :defaultCurrent="10"
          v-model="current"
          :total="total"
          @change="pageChange"
        />
      </div>
    </a-spin>
  </div>
</template>
<script>
import { getMsgList, putObj, getCount, delObj } from '@/api/message/notification'
import Ellipsis from '@/components/Ellipsis'
export default {
  components: {
    Ellipsis
  },
  data () {
    return {
      spinning: true,
      msgList: [],
      formData: {},
      queryParam: {},
      current: 0,
      total: 0
    }
  },
  created () {
    this.selectMessage()
  },
  methods: {
    // 查询消息列表
    selectMessage () {
      getMsgList(Object.assign(this.queryParam)).then(res => {
        this.msgList = res.result.records
        this.total = res.result.total
        this.current = res.result.current
        this.spinning = false
      })
    },
    pageChange (page, pageSize) {
      this.spinning = true
      this.queryParam.current = page
      this.selectMessage()
    },
    routerTo (id) {
      this.formData.id = id
      this.formData.isRead = '1'
      putObj(this.formData).then(() => {
        this.$router.push({
          path: `notificationDetail`,
          query: {
            id: id
          }
        })
        // 更新消息条数
        getCount().then(res => {
          this.$store.commit('SET_MSG_COUNT', res.result)
        })
      })
    },
    remove (id) {
      this.spinning = true
      delObj(id).then(() => {
        this.$message.success('删除成功')
      }).catch(() => {
        this.$message.error('删除失败')
      }).finally(() => {
        this.queryParam.current = 1
        this.selectMessage()
      })
    }
  }
}
</script>

<style  lang="less" scoped>
.dustyl {
  width: 50px;
  height: 50px;
}
.notification {
  padding: 15px 10px;
  cursor: pointer;
}
.notification:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); // 阴影做的悬浮效果
}
</style>
